import React, {
  Component,
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  useImperativeHandle,
} from "react";
import { createPortal } from "react-dom";

import { Cropper, Navigation } from "react-mobile-cropper";
import "react-mobile-cropper/dist/style.css";

import Menu from "../toolbar/crop/CropMenu";

import General from "../../../utils/General";
import Backend from "../../../utils/Backend";

const CustomCropper = React.forwardRef(({ state, image, onUpdated }, ref) => {
  const [rotation, setRotation] = useState(null);
  const [controlPanelElement, setControlPanelElement] = useState(null);

  const [controlPanel, setControlPanel] = useState(null);
  const [progress, setProgress] = useState(-1);

  const cropperRef = useRef();

  const { transform } = state;

  useLayoutEffect(() => {
    let element = document.getElementById(`${state.currentTab}-controls`);
    setControlPanelElement(element);
  }, [state.currentTab]);

  useEffect(() => {
    if (!controlPanelElement) {
      return null;
    }
    _setup();
    setControlPanel(createPortal(_renderControls(), controlPanelElement));
  }, [controlPanelElement, rotation]);

  function _setup() {
    if (!transform.cropper) {
      return;
    }
  }

  useImperativeHandle(ref, () => ({
    applyChanges,
  }));

  const applyChanges = () => {
    _update(state);
  };

  function _update(state, shouldUpdateImage = true) {
    const cropper = cropperRef.current;
    if (shouldUpdateImage) {
      setProgress(0);
      console.log(
        "Crop canvas WxH",
        cropper.getCanvas()?.width,
        cropper.getCanvas()?.height
      );

      cropper.getCanvas()?.toBlob((blob) => {
        console.log("blob size ", blob?.size);

        uploadImage(blob)
          .then((image) => {
            setProgress(-1);
            setTimeout(() => {
              updateState(state, image);
            }, 300);
          })
          .catch((e) => {
            setProgress(-1);
            console.log(e);
          });
      });
    } else {
      updateState(state);
    }
  }

  function updateState(state, newImageObj = null) {
    let tool = "straighten";
    const cropper = cropperRef.current;
    let cropperState = cropper.getState();

    let data = General.clone(state);

    if (newImageObj) {
      data.retouched_image = newImageObj;
    }

    data.transform = {
      ...state.transform,
      cropper: { ...cropperState },
    };
    if (rotation === 0 || rotation === 90) {
      tool = "rotate";
    }
    onUpdated(data, tool);
  }

  async function uploadImage(file) {
    if (!file) {
      return Promise.reject("File not found");
    }

    try {
      let cropper = cropperRef.current;
      let canvas = cropper.getCanvas();

      if (!canvas) {
        return Promise.reject("Canvas not ready, Please wait and retry.");
      }

      let meta = {
        title: "crop.png",
        width: canvas.width,
        height: canvas.height,
      };

      let newImage = await Backend.uploadImage(file, meta, (p) => {
        setProgress(p.toFixed(0));
      });
      return Promise.resolve(newImage);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  function _renderStraighten() {
    const cropper = cropperRef.current;
    if (!cropper) {
      return null;
    }
    let transforms = cropper.getTransforms();
    return (
      <Navigation
        value={rotation || transforms.rotate}
        onRotate={cropper.rotateImage}
        onRotateEnd={cropper.transformImageEnd}
        onFlip={cropper.flipImage}
        valueBarClassName={"cropper"}
        zeroBarClassName={"cropper"}
        highlightedBarClassName={"cropper"}
      />
    );
  }

  function _renderAspect() {
    return (
      <Menu
        onAspectRatioChanged={(aspect) => {
          let data = General.clone(state);
          data.transform.aspectRatio = aspect.value;
          _update(data, false);
        }}
        aspectRatio={transform.aspectRatio}
      />
    );
  }

  function _renderControls() {
    if (state.currentTab == "straighten") {
      return _renderStraighten();
    }
    return _renderAspect();
  }

  return (
    <div className={`crop-preview cp-${state.currentTab}`}>
      <Cropper
        ref={cropperRef}
        src={image.original}
        className={"cropper"}
        navigation={false}
        resizeImage={false}
        stencilProps={{
          aspectRatio: transform?.aspectRatio || "",
        }}
        onReady={() => {
          _setup();
        }}
        transitions={false}
        onChange={() => {
          setRotation(cropperRef.current.getTransforms().rotate);
        }}
        onInteractionEnd={() => {
          // _update(state);
        }}
        onTransformImageEnd={(data) => {
          // _update(state);
        }}
      />
      {controlPanel}

      {progress !== -1 && (
        <div
          style={{
            backgroundColor: "#00000080",
            color: "white",
            position: "fixed",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 1,
            fontSize: 20,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          Please wait...{progress}%
        </div>
      )}
    </div>
  );
});

export default CustomCropper;
